import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'myleo-feature-item',
  styleUrl: 'myleo-feature-item.css',
  shadow: true,
})
export class MyleoFeatureItem {
  @Prop() icon: string;

  @Prop({
    reflect: true
  })
  ariaRole = "list-item";

  @Prop() inverted = false;

  render() {
    return (
      <Host>
        {this.icon ? <div class="icon-container"><img src={this.icon} alt="" width={16} height={16} /></div> : ''}
        <slot></slot>
      </Host>
    );
  }

}
